var footer = {    
    home:"Inicio",
    registerbooking:"Registrar una Reserva",
    track:"Rastrear y Canjear",
    details:"Detalles y PP. FF.",
    followUs:"Síguenos",
    privacyPolicy:"Aviso de Privacidad",
    cookiePolicy:"Política de Cookies",
}
module.exports = footer

